<img v-if="gravatarExist" class="avatar" loading="lazy" :src="img" :alt="`${firstName} ${lastName}`"/>
<svg v-else width="1em" class="avatar" viewBox="0 0 20 20" role="img" focusable="false">
	<title>{{firstName}} {{lastName}}</title>
	<rect class="avatar-bg" :fill="color" x="0" y="0" width="20" height="20" />
	<text x="2" y="18" class="avatar-text" :class="isDark">{{initials}}</text>
</svg>
